<template>
  <div class="col-12 comment-editor nopads">
    <div class="col-12" v-if="photo">
      <div
        style="height: 15em"
        class="mt-1 mb-2"
      >
          <img
              :src="photo"
              class="img-fluid d-block mx-auto"
              style="border: none; height: 100% !important;"
          />
      </div>
    </div>
    <div class="col-12 nopads">
        <textarea
            v-model="comment"
            class="form-control col-12"
            :placeholder="$t('comments.write_comment')"
            rows="3"
        />
    </div>
    <div class="row nopads pt-2 pb-2">
      <div
        class="col nopads pr-1"
      >
          <div class="mb-3">
              <div class="input-group input-group-sm">
                  <label for="fileInput" class="btn btn-outline-primary" style="border-radius: .3em !important">
                      {{ $t('common.add_photo') }}
                  </label>
                  <input
                      type="file"
                      id="fileInput"
                      class="form-control form-control-sm custom-file-input d-none"
                      accept="image/jpeg, image/jpg, image/png"
                      @change="onFileChange"
                  />
              </div>
          </div>
      </div>
      <div class="col nopads pr-1">
        <div class="col-12 nopads d-flex justify-content-end">
          <button class="btn btn-secondary btn-sm form-button" @click="resetData">
            {{ $t('common.clear') }}
          </button>
          <button class="btn btn-sm btn-success form-button" :disabled="loading || (!comment || comment.length < 1)" @click="submitComment">
            {{ $t('common.send') }}
          </button>
        </div>
      </div>
    </div>
    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
  </div>
</template>

<script>
import {restApi} from '../mixins/RestApiMixin'
import {timeUtils} from "@/components/mixins/TimeUtils";

export default {
    name: 'CommentEditor',
    mixins: [restApi, timeUtils],
    props: {
        user: {
            type: Object,
            required: true
        },
        topic: {
            type: Number,
            required: true
        },
        id: {
            type: Number,
            required: true
        },
        type: {
            type: Number,
            required: false
        },
        customApiUrl: {
            type: String,
            required: false,
            default: null
        }
    },
    data: function () {
        return {
            comment: '',
            photo: null,
            file: null,
            loading: false
        }
    },

    methods: {

        submitComment() {
            if (this.comment) {
                const comment = {
                    topic: this.topic,
                    record_id: this.id,
                    type: this.type,
                    comment: this.comment,
                    photo: this.photo
                }
                this.loading = true
                this.restAdd(this.customApiUrl ? this.customApiUrl : this.commentUrl, comment, this.success, this.fail)
            }
        },

        success() {
            this.loading = false
            this.$emit('commentAdded')
            this.resetData()
        },

        fail() {
            this.loading = false
            // TODO - Show error to user
        },

        resetData() {
            this.comment = null
            this.file = null
            this.photo = null

        },

        onFileChange(event) {
            const file = event.target.files[0]; // Get the first selected file
            if (file) {
                const reader = new FileReader();
                reader.onload = (e) => {
                    this.photo = e.target.result; // Base64 string
                };
                reader.onerror = () => {
                    // TODO - Inform user about error
                };
                reader.readAsDataURL(file); // Read file as Base64
            } else {
                this.photo = null
            }
        },
    }
}
</script>
<style>

.comment-editor {
    margin-top: .35em;
    padding-top: .35em;
    background: #ffffff;
    margin-bottom: .25em;
}

</style>
